// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__lD+ts","nav_link":"Navigation_nav_link__G06Nw","arrow_Icon":"Navigation_arrow_Icon__Mllpa","nav_item":"Navigation_nav_item__VXvAD"};